export const _en = {
    name: {
        label: "Name"
    },
    description: {
        label: "Description"
    },
    color: {
        label: "Color"
    },
    refTaskCategoryId: {
        label: "Task category"
    },
    defaultStartHour: {
        label: "Default start hour",
        tooltip: "The start time will be automatically selected when creating a session of this type"
    },
    defaultFinishHour: {
        label: "Default finish hour",
        tooltip: "The finish time will be automatically selected when creating a session of this type"
    },
    isUnavailabilityType: {
        label: "Is availability"
    },
    refCounterId: {
        label: "Counter"
    },
    refPayId: {
        label: "Pay"
    }
};

export const _fr = {
    name: {
        label: "Nom"
    },
    description: {
        label: "Description"
    },
    color: {
        label: "Couleur"
    },
    refTaskCategoryId: {
        label: "Catégorie de séance"
    },
    defaultStartHour: {
        label: "Heure de début par défaut",
        tooltip: "L'heure de début sera automatiquement choisie lors de la création d'une séance de ce type"
    },
    defaultFinishHour: {
        label: "Heure de fin par défaut",
        tooltip: "L'heure de fin sera automatiquement choisie lors de la création d'une séance de ce type. Pour une durée 24h/48H/72H... sélectionner 00:00"
    },
    isUnavailabilityType: {
        label: "Les activités de cette catégorie sont de l’indisponibilité"
    },
    refCounterId: {
        label: "Compteur"
    },
    refPayId: {
        label: "Paie"
    }
};